"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATES_AND_FEES_PREMIUMS = exports.getNumberFromPremium = exports.getRatesAndFeesPremiumAmountFromAgreementUrl = exports.getRatesAndFeesJsonUrl = exports.getPremiumFromAgreementUrl = exports.NoticeKey = exports.AgreementKey = exports.AgreementsEndpoints = void 0;
var AgreementsEndpoints;
(function (AgreementsEndpoints) {
    AgreementsEndpoints["AcknowledgeAgreement"] = "/agreements/acknowledge-agreement";
    AgreementsEndpoints["GetAgreementsToAcknowledge"] = "/agreements/get-agreements-to-acknowledge";
    AgreementsEndpoints["GetApplicationAgreements"] = "/agreements/get-application-agreements";
    AgreementsEndpoints["GetStaticDisclosures"] = "/agreements/get-static-disclosures";
})(AgreementsEndpoints || (exports.AgreementsEndpoints = AgreementsEndpoints = {}));
var AgreementKey;
(function (AgreementKey) {
    AgreementKey["Schumer"] = "SCHUMER";
    AgreementKey["CardholderAgreement"] = "CARDHOLDER_AGREEMENT";
    AgreementKey["Esign"] = "ESIGN";
    /** Telephone Consumer Protection Act Notice */
    AgreementKey["TCPA"] = "TCPA";
    AgreementKey["TermsOfService"] = "TERMS_OF_SERVICE";
    AgreementKey["RewardsTerms"] = "REWARDS_TERMS";
    AgreementKey["PrivacyNotice"] = "PRIVACY_NOTICE";
})(AgreementKey || (exports.AgreementKey = AgreementKey = {}));
var NoticeKey;
(function (NoticeKey) {
    NoticeKey["InformationSharing"] = "INFORMATION_SHARING";
    NoticeKey["ImportantTerms"] = "IMPORTANT_TERMS";
})(NoticeKey || (exports.NoticeKey = NoticeKey = {}));
const RATES_AND_FEES_PREMIUMS = [
    'default', // no-fee
    'premium', // legacy $99
    'premium-79',
    'premium-99',
    'premium-99-qatar',
    'premium-99-avianca',
    'premium-199-alibaba',
    'premium-249-avianca',
    'premium-499-qatar',
];
exports.RATES_AND_FEES_PREMIUMS = RATES_AND_FEES_PREMIUMS;
const getPremiumFromAgreementUrl = (pdfUrl = '') => {
    const matches = pdfUrl.match(/schumer\/(.+?)\//);
    const premium = (matches === null || matches === void 0 ? void 0 : matches.length)
        ? matches[1]
        : undefined;
    return premium;
};
exports.getPremiumFromAgreementUrl = getPremiumFromAgreementUrl;
const getNumberFromPremium = (premium) => {
    let stringAsNumber;
    switch (premium) {
        case 'default':
            return 0;
        case 'premium':
            return 99;
        default:
            stringAsNumber = premium
                ? Number(premium === null || premium === void 0 ? void 0 : premium.replace(/^premium-(\d+)(-.+?)?$/, '$1'))
                : 0;
            if (isNaN(stringAsNumber)) {
                throw new Error(`getPremiumAmountFromAgreementUrl invariant violation: unable to parse premium ${stringAsNumber}`);
            }
            else {
                return stringAsNumber;
            }
    }
};
exports.getNumberFromPremium = getNumberFromPremium;
const getRatesAndFeesPremiumAmountFromAgreementUrl = (pdfUrl = '') => {
    const premium = getPremiumFromAgreementUrl(pdfUrl);
    return getNumberFromPremium(premium);
};
exports.getRatesAndFeesPremiumAmountFromAgreementUrl = getRatesAndFeesPremiumAmountFromAgreementUrl;
const getRatesAndFeesJsonUrl = ({ env, premium, }) => {
    const hostSuffix = env === 'production' ? '' : '-staging';
    const path = `/schumer/${premium || 'default'}/rates_and_fees.json`;
    const url = `https://legal.cardless${hostSuffix}.com${path}`;
    return url;
};
exports.getRatesAndFeesJsonUrl = getRatesAndFeesJsonUrl;
